import { RELATIVE_TIME_BY_LOCALE } from '@protector/utils/app-locale-map';
import type { LocaleSpecification } from 'moment';

export const getMomentLocaleSpecification = (locale: string): LocaleSpecification => {
  const relativeTime = RELATIVE_TIME_BY_LOCALE[locale];

  return relativeTime ? { relativeTime } : {};
};
